import { type FC } from "react";

import * as Styled from "./ChartTooltip.styles";
import { useChartTooltip } from "./useChartTooltip";

export const ChartTooltip: FC = () => {
  const { boxes, leftPercent, isFlipped } = useChartTooltip();

  if (!boxes.length) {
    return null;
  }

  return (
    <Styled.Root $leftPercent={leftPercent} $isFlipped={isFlipped}>
      {boxes.map(({ title, rows }, boxIndex) => (
        <Styled.TooltipBox key={title ?? boxIndex}>
          {title && <Styled.Title>{title}</Styled.Title>}

          {rows.map(
            ({ key, color, label, sublabel, chanceLabel, isConsensus }) => (
              <Styled.Row key={key}>
                <Styled.RowInfo>
                  <Styled.Dot $color={color} />

                  <Styled.LabelBlock>
                    <Styled.Label $isConsensus={isConsensus}>
                      {label}
                    </Styled.Label>
                    <Styled.Sublabel $isConsensus={isConsensus}>
                      {sublabel}
                    </Styled.Sublabel>
                  </Styled.LabelBlock>
                </Styled.RowInfo>

                <Styled.Price $isConsensus={isConsensus}>
                  {chanceLabel}
                </Styled.Price>
              </Styled.Row>
            )
          )}
        </Styled.TooltipBox>
      ))}
    </Styled.Root>
  );
};
